import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('working-group-member/index', {params});
    },
    getGroupMember(params) {
        return Service().get('working-group-member/get-working-group-member', {params});
    },
    show(id) {
        return Service().get('working-group-member/show/'+id);
    },
    create(params) {
        return Service().post('working-group-member/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('working-group-member/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('working-group-member/delete/'+id);
    },
}